import {
  getApiBaseUrl,
  getAuthHeaderName,
  getAuthHeaderPrefix,
} from '@/config/api/env'
import { getAccessToken } from '@/config/api/authStore'

function resolveApiUrl(path) {
  const base = getApiBaseUrl()
  return base ? `${base}${path}` : path
}

function authHeaders() {
  const token = getAccessToken()
  if (!token) return {}
  return { [getAuthHeaderName()]: `${getAuthHeaderPrefix()}${token}` }
}

function streamPath(path) {
  return path.endsWith('/stream') ? path : `${path}/stream`
}

export async function postHermesStreamResponse({ path, body, signal }) {
  return fetch(resolveApiUrl(streamPath(path)), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(body),
    signal,
  })
}
